import {Injectable, Inject, LOCALE_ID, isDevMode} from '@angular/core';
import {UserAuth, DialogService} from "@nrwl/common-lib";
import { SUPPORTED_LANG } from './variables';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  userAuth: UserAuth;
  dev: boolean = isDevMode();
  userLang: string = navigator.language;
  currUrl: string = window.location.href;
  currHostname: string = window.location.hostname;
  currProtocol: string = window.location.protocol;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject(SUPPORTED_LANG) private supportedLang: string[],
    public userAuthValue: UserAuth,
    private readonly dialogService: DialogService
  ) {
    this.userAuth = this.userAuthValue;
  }

  // attempts to override language in URL by forcefull redirect to another URL
  // (eg, localhost/en/ to localhost/de/). Please note that corresponding language
  // may not exist (currently we build project for each locale - so the list of supported
  // locales is finite). The rules in dockerfile/nginx config takes care to default
  // to /en/ locale, if user-specific locale does not exist.
  updateLocale(chosenLang: string): void {
    let buildLang = this.locale.split("-", 1)[0];

    if (!this.dev) {
      if (chosenLang) {
        //when called from profile, already authenticated user
        buildLang = chosenLang;
      } else if (this.userLang) {
        buildLang = this.userLang.split("-", 1)[0];
      }

      // if preferred language is /en, do not try to redirect from / to /en/ - that's useless waste of time,
      // as default language is english anyway.
      if (buildLang === 'en') {
        return;
      }

      //If user language is not supported change it to english
      if(!this.supportedLang.some(lang => lang === buildLang)) {
        buildLang = "en";
      }

      //TODO logic for changing language from login/profile - un/authenticated
      if (this.currUrl.search(`/${buildLang}/`) === -1 && !chosenLang) {
        let token = null;
        try {
          token = this.userAuth.getUserAuth().token;
        } catch (e) {
          console.warn("Cannot get user details.");
        }
        if (!token) {
          window.location.href = `${this.currProtocol}//${this.currHostname}/${buildLang}/`;
        } else {
          this.dialogService.showInfo("information", "body", "Language settings has been updated, please re-login to see the changes.", "Locale Support");
        }
      }
    }
  }
}
